import { fbButton as fb, tw, linkedin as li } from "vanilla-sharing";

const init = el => {
    if (!el) {
        return;
    }

    // const url = "https://unearthed.solutions/news/back-future-mining-our-recap"; // For testing
    const url = window.location.href;
    const title = document.title;

    const facebook = el.querySelector("[data-type='facebook']");
    facebook && facebook.addEventListener("click", () => fb({ url }));

    const twitter = el.querySelector("[data-type='twitter']");
    twitter && twitter.addEventListener("click", () => tw({ url, title }));

    const linkedin = el.querySelector("[data-type='linkedin']");
    linkedin && linkedin.addEventListener("click", () => li({ url, title }));
};

const share = () => {
    const share = document.querySelector(".share");
    share && init(share);
};

export default share;
